import Btn from '@app/lui2/Btn';
import Luiv3Constants from '@app/lui3/constants';
import FaIcon from '@app/lui3/FaIcon';
import styled from 'styled-components';

import {useOfficeAuthDialog} from './useOfficeAuthDialog';

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
  padding: 1.5rem;
  text-align: center;
`;

const ErrorText = styled.p`
  margin: 0.75rem 0 0;
  color: ${Luiv3Constants.baseColor['red-500']};
  font-size: 0.875rem;
`;

const LoginScreen = () => {
  const {openLoginDialog, isOpening, error} = useOfficeAuthDialog();

  return (
    <Container>
      <Btn
        onClick={openLoginDialog}
        disabled={isOpening}
        after={<FaIcon icon="arrow-up-right" />}
      >
        {isOpening ? 'Opening sign-in…' : 'Sign in on Loxo'}
      </Btn>
      {error ? <ErrorText>{error}</ErrorText> : null}
    </Container>
  );
};

export default LoginScreen;
